<template>
  <div id="app">
    <CursoPage :items="imageData" />
  </div>
</template>

<script>
import  CursoPage from "../components/CursoPage";
export default {
  components: {
   CursoPage,
  },
  data() {
    return {
      imageData: [], // Array to store data retrieved from the backend
    };
  },
};
</script>
<style scoped></style>
